/**
 * 道具索要通用mixins
 * 主要是 Detail.vue 里通用的一部分逻辑
 * 该MIxin依赖组件里的
 *    openPromptPropBuy | closePropBuy
 */

import { mapGetters, mapActions } from "vuex"
import * as mobileGameBusiness from "../../business/mobilegame"
import * as gameProps from "@api/gameProps"
import * as enums from "@store/enums"
import * as errorMaps from "@constants/error_map"
import * as url from "@utils/url"
import * as reportDict from "@constants/report-dictonary"

export default {
  data() {
    return {
      // 索要锁，如果用户点击购买后不可重复点击
      enableDemand: true
    }
  },

  computed: {
    ...mapGetters(["userAgent", "currentItem", "provideAccountType", "loginState", "pfSource", "avatar"]),
    // 是否是端游专区
    isPcGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.PC_GAME
    },
    // 是否是手游专区
    isMobileGame() {
      return this.currentItem.categoryId === enums.BUSINESS_TYPE.MOBILE_GAME
    },
    // 是否支持索要 【 索要道具要求用户先选择好大区信息，后下单】
    supportDemand() {
      // 业务索要配置 索要菜单=索要渠道&索要菜单=索要渠道
      if (this.currentItem?.demandSource) {
        let propMenus =
          this.currentProp?.menuInfo?.map(menu => {
            return menu.menuId
          }) || []

        let demandConfig = url.getStrParams(this.currentItem.demandSource)
        let demandMenus = Object.keys(demandConfig)

        let canDemand = false
        demandMenus?.forEach(menu => {
          if (propMenus.indexOf(menu) > -1) {
            // 道具菜单里包含可索要菜单
            if (demandConfig[menu]?.indexOf(this.pfSource) > -1) {
              canDemand = true
            }
          }
        })
        if (!canDemand) return false
      } else {
        return false
      }

      // 道具+渠道层面做索要的入口开放，产品自己运营哪些渠道的哪些道具可以在游戏外索要 || DemandSource必填项
      if (this.currentProp?.goodsExtend?.DemandSource) {
        // 如果当前source不在白名单内则不允许索要
        if (
          this.currentProp.goodsExtend.DemandSource.indexOf(this.pfSource) === -1 &&
          this.currentProp.goodsExtend.DemandSource.indexOf("all") === -1
        ) {
          return false
        }
      }

      // 目前无用
      if (this.currentProp?.goodsExtend?.DemandSourceBlacklist) {
        // 如果当前source在黑名单内则不允许索要
        if (this.currentProp.goodsExtend.DemandSourceBlacklist.indexOf(this.pfSource) > -1) {
          return false
        }
      }

      // 目前无用
      // 按设备端口限制是否能索要，比如iOS不可索要 || 游客登录态不可索要 =>设备端口限制一般用不上
      if (this.currentProp?.goodsExtend?.DemandValidTerminal) {
        let terminal = `${this.userAgent.iOS ? "ios" : "android"}_${this.provideAccountType.toLowerCase()}`
        if (this.currentProp.goodsExtend.DemandValidTerminal.indexOf(terminal) === -1 || this.loginState.sessionType === "st_dummy") {
          // 只有当限制终端明确配置了可用终端且不包含当前终端，才拦截
          return false
        }
      }

      // 游客不可索要
      if (this.loginState?.sessionType === "st_dummy") {
        return false
      }

      // 目前不允许iOS索要
      if (this.userAgent.iOS) {
        return false
      }

      // 不可售卖道具不可索要 —— 理论走不进，因为不可购买时只展示不可购买的按钮
      if (!gameProps.checkPropCanBuy(this.currentProp)) {
        return false
      }

      // 预售不支持索要
      if (this.currentProp?.goodsExtend && this.currentProp.goodsExtend.ActivityType === "preOrder") {
        return false
      }

      // 第三方登录态不支持索要（快手场景内需要展示索要按钮，用户点击引导绑定） || 电信币场景不支持索要(通过source来控制)
      // if (this.checkThirdSession) {
      //   return false
      // }

      // 组合礼包一期不支持索要
      if (this.currentProp?.goodsExtend?.PackageGift) {
        return false
      }

      // 团购和索要不能同时发生
      if (this.propsGroupActivity) {
        return false
      }

      return true
    }
  },

  methods: {
    ...mapActions([
      "reportUserAction",
      "setToastMsg",
      "setDialogMsg",
      "setLoadingStart",
      "setLoadingEnd",
      "getUserSubscribe",
      "rechargeAMSGoods",
      "demandAMSGoods",
      "payAMSGoods"
    ]),

    commitDemand({ goods, userZoneInfo }) {
      // 如果缓存用户已购买，则弹窗提示已拥有
      if (
        this.hasProp ||
        (goods.itemExtend &&
          goods.itemExtend.Singleton == 1 &&
          gameProps.checkLocalBuyedProp({
            openid: this.checkThirdSession && userZoneInfo?.bind_user_id ? userZoneInfo.bind_user_id : this.loginState.openid,
            gameid: userZoneInfo.gameid || "",
            productId: goods.itemExtend.AMSID,
            offerId: this.currentItem.ams.offerid
          }))
      ) {
        this.setDialogMsg("您已拥有该物品，无需重复索要哦")
        return
      }

      this.enableDemand = false
      let params = {
        payOfferId: this.currentItem.ams.offerid,
        deliverOfferId: this.currentItem.ams.offerid,
        // 专门给端游点券道具下单使用，表示购买数量
        quantity: 1,
        zoneId: userZoneInfo.zoneId,
        zoneName: userZoneInfo.zoneName || "",
        gameid: userZoneInfo.gameid,
        gamePlatformId: userZoneInfo.gamePlatformId || "",
        clientVersion: this.isMobileGame ? (this.userAgent.iOS ? "iap" : "android") : "html5",
        productName: goods.name,
        productId: mobileGameBusiness.getVmallProductId(goods),
        productSalePrice: goods.saleCashPrice,
        gameType: this.isPcGame ? "pc" : "mobile",
        // 纯背包过滤
        action: "check_user_goods_info"
      }

      // 传递vmall的goodsId，为了给后台在activityproc环节校验道具是否在线且可售卖
      if (goods?.goodsId) params.vmallGoodsId = goods.goodsId

      // 先activityproc做背包过滤，后索要，以防止因为背包过滤导致扣除了索要的次数
      this.payAMSGoods(params)
        .then(() => {
          this.confirmDemandAMSGoods(params, goods, userZoneInfo)
        })
        .catch(res => {
          let promptText = ""
          let needConfirm = false

          if (res.errCode && res.errCode === 2311) {
            promptText = `您还没有${goods.itemExtend.HeroName}英雄，是否继续索要皮肤`
            needConfirm = true
          } else if (res.errCode && res.errCode === 2312) {
            promptText = goods?.itemExtend?.RelyItemId
              ? `您还没有${goods.itemExtend.RelyItemName || ""}皮肤，是否继续索要星元皮肤?`
              : `您还没有${goods.itemExtend.RelyItemName || ""}，是否继续索要该道具?`
            needConfirm = true
          } else if (res.errCode && res.errCode === 2313) {
            promptText = "您已拥有套装中的部分单品，是否继续索要完整套装?"
            needConfirm = true
          } else if (res.errCode && res.errCode === 2314) {
            promptText = "已拥有当前最新战令，无需重复索要"
            needConfirm = false
          } else if (res.errCode && res.errCode === 2315) {
            promptText = "已拥有当前最新战令，无需重复索要"
            needConfirm = false
          } else if (res.errCode && res.errCode === 2316) {
            promptText = `您还没有${goods.itemExtend.RelyItemName || ""}，暂时无法索要该道具`
            needConfirm = false
          } else if (res.errCode && res.errCode === 2310) {
            this.setDialogMsg("您已拥有该物品，无需重复索要哦")
          } else {
            this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
          }

          // 重构benny部分代码，将prompt抽出来
          if (promptText) {
            if (needConfirm) {
              let promptInstance = this.$PromptControl({
                msgText: promptText,
                cancelText: "取消",
                onConfirm: () => {
                  this.confirmDemandAMSGoods(params, goods, userZoneInfo)
                  promptInstance?.hide()
                }
              })
              promptInstance?.show()
            } else {
              this.$Prompt({
                msgText: promptText
              })
            }
          }
        })
        .finally(() => {
          this.enableDemand = true
        })

      // 纯索要点击，可能没有真实索要
      this.reportUserAction({
        iformat: reportDict.CLICK.DETAIL_DEMAND_ACTION,
        pfStructure: this.$route.query.pfStructure,
        resultInfo: {
          productId: goods?.itemExtend?.AMSID
        }
      })
    },

    confirmDemandAMSGoods(params, goods, userZoneInfo) {
      this.enableDemand = false
      this.demandAMSGoods(params)
        .then(res => {
          this.handleDemandRes(res, goods, userZoneInfo)
        })
        .catch(res => {
          if (res.errCode && res.errCode === 2310) {
            this.setDialogMsg("您已拥有该物品，无需重复索要哦")
          } else if (res?.err_code == "" && res.msg) {
            // 若err_code为空，则透传错误码提示用户
            this.setToastMsg(res.msg)
          } else if (res?.err_code == "1138-1-150351") {
            this.setToastMsg("您今天的索要已达到限制，请明天再发起。")
          } else if (res?.err_code == "1138-1-61001") {
            this.setToastMsg("您的账号尚未完成实名认证，请在游戏内完成实名认证后再发起索要")
          } else {
            this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
          }
        })
        .finally(() => {
          this.enableDemand = true
        })

      this.reportUserAction({
        iformat: reportDict.CLICK.DETAIL_DEMAND,
        pfStructure: this.$route.query.pfStructure,
        resultInfo: {
          productId: goods?.itemExtend?.AMSID
        }
      })
    },

    handleDemandRes(res, goods, userZoneInfo) {
      if (res?.friends_pay_url_v2) {
        // 如果在手Q或微信里直接跳转代付页，其他场景直接拉起分享海报，因为非手Q微信无法打开代付页
        if (gameProps.supportDemandDirectSence()) {
          location.href = res.friends_pay_url_v2
        } else {
          // 生成分享图
          this.setLoadingStart()
          this.$SharePrompt({
            shareUrl: res.friends_pay_url_v2,
            mainImg: goods.hdIcon,
            logoImg: this.currentItem?.serviceZoneMaterial?.txczAndBizLogo || "",
            name: goods.name,
            price: `¥${goods.saleCashRMBPrice}`,
            friendsGreet: "Hi~ 在吗!",
            friendsMsg: "我想要这个礼物很久了，可以帮我买吗?",
            demander: "你的朋友",
            demanderNick: `${userZoneInfo.roleName}`,
            demanderAvatar: this.avatar,
            shareTips: "长按或截图保存图片，邀请好友来代付吧~",
            hideShareArrow: true,
            onComplete: () => {
              this.setLoadingEnd()
              this.reportUserAction({
                iformat: reportDict.PAGE_VIEW.FRIENDPAY_POSTER,
                resultInfo: {
                  productId: goods?.itemExtend?.AMSID
                }
              })
            },
            onError: () => {
              this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
            }
          })
        }
      } else {
        this.setToastMsg(errorMaps.USER_HELPER.SYSTEM_BUSY)
      }
    },

    clickDemandButton(goods) {
      // 支付前校验
      if (this.isStDummyLoginState) {
        this.showAppLogin()
        return
      }
      if (!this.checkUserPrivacy(this.currentItem)) {
        return
      }
      if (!this.enableDemand || !this.supportDemand) return

      let userZoneInfo = this.getZoneSelectorCacheZoneInfo({
        offerId: this.currentItem?.ams?.offerid,
        userId: this.getAccountId(),
        forceSelectedRole:
          Number(this.currentItem.busId) === 95 || this.currentItem?.game_info?.check_type === enums.CHECK_ROLE_TYPE.SELECT_ROLE
            ? true
            : false
      })

      // 索要前提是该道具已上线，预售道具不可索要
      if (!userZoneInfo?.zoneId || !userZoneInfo?.gameid) {
        this.setToastMsg("请先选择游戏分区")
        return
      }

      this.commitDemand({ goods, userZoneInfo })
    }
  }
}
